var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#616161;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,18c0,9.9-8.1,18-18,18C8,36,0,27.9,0,18C0,8.1,8.1,0,18,0C27.9,0,36,8.1,36,18L36,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,16c-0.4-0.4-0.9-0.7-1.4-0.6h-4.5c-0.1,0-0.1-0.1-0.2-0.1c0,0,0-0.1,0-0.2l1.5-2.7 c0.3-0.5,0.3-1.2,0.1-1.7c-0.3-0.6-0.9-0.9-1.5-0.9c-0.9,0-1.8,0.4-2.5,1.1L15.3,14c-0.2,0.2-0.3,0.5-0.3,0.8v10 c0,0.5,0.3,1,0.9,1.1c0.5,0.1,1.1,0.3,1.7,0.3h5.3c1.2-0.1,2.1-0.9,2.4-2l1.7-6.6C27.1,17,27,16.4,26.6,16L26.6,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,14.6h-2.2c-0.8,0-1.5,0.7-1.5,1.5v8.2c0,0.8,0.7,1.5,1.5,1.5h2.3c0.8,0,1.5-0.7,1.5-1.5v-8.2 C14.3,15.3,13.6,14.6,12.7,14.6L12.7,14.6z M11.8,24.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9 C12.8,23.7,12.3,24.2,11.8,24.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/Interest.57bf5a2378dc09e3ba01b7aa3bc7791e.svg";
export { ForwardRef as ReactComponent };